// TeamMembers.js
import React, { useEffect, useState } from 'react';
import TeamMember from './TeamMember';
import './TeamMembers.css';
import {teamData} from './teamData';
import Seo from '../components/Seo';
import { useI18n } from '../i18n/I18nContext';

const TeamMembers = () => {
  const { t } = useI18n();
  const [teamMembers, setTeamMembers] = useState([]);
  //const [error, setError] = useState(null);

  //get team data from teamData.js
  useEffect(() => {
    const members = [...teamData];
    const ziruiIndex = members.findIndex((member) => member.id === 8);
    if (ziruiIndex > 1) {
      const [zirui] = members.splice(ziruiIndex, 1);
      members.splice(1, 0, zirui);
    }
    setTeamMembers(members);
  }, []);

  return (
    <div className="team-members">
      <Seo
        title={t('team.seoTitle')}
        description={t('team.seoDescription')}
        path="/team"
      />
      <h1 className="team-title">{t('team.title')}</h1>
      {teamMembers.map((member) => (
        <TeamMember key={member.id} {...member} />
      ))}
    </div>
  );
};

export default TeamMembers;
